module.exports = __webpack_public_path__ + "9400bd9f7e0e11aeb8427542d10f9f21.png";